export const phoneNumberTools = {
    getAdjustedPhoneNumber: phone => {
        if(phone === null) {
            return '';
        }
        const phoneToString = String(phone);
        if(phoneToString.length === 10 && phoneToString.match(/^[0-9]/)) {
            return `(${phoneToString.slice(0, 3)}) ${phoneToString.slice(3, 6)}-${phoneToString.slice(6)}`;
        } else {
            return phoneToString;
        }

    },
    getPhoneNumberDetails : (phoneNumber, phoneType, phoneExtension) => {
        if(phoneNumber === null) {
            return '';
        }
        const phoneToString = String(phoneNumber);
        const extension = phoneExtension ? String(phoneExtension) : '';
        if(phoneToString.length === 10 && phoneToString.match(/^[0-9]/)) {
            return (`${phoneType !== null ? phoneType : ''} (${phoneToString.slice(0, 3)}) ${phoneToString.slice(3, 6)}-${phoneToString.slice(6)} ${extension && `ext - ${extension}`}`);
        } else {
            return phoneToString;
        }

    },

    cleanedUpPhone: phone => {
        return typeof phone === 'string' ?
            phone.split('').filter(ch => ch.match(/^[0-9]*$/)).join('') : null;
    },

    autoFillPhone: (phone, previousPhoneValue) => {
        let result;
        switch(true) {
            case phone.length < previousPhoneValue.length:
                switch (phone.length) {
                    case 1:
                        result = ''; break;
                    case 5:
                        result = phone.slice(0, phone.length - 1); break;
                    case 6:
                        result = phone.slice(0, phone.length - 2); break;
                    case 10:
                        result = phone.slice(0, phone.length - 1); break;
                    default:
                        result = phone;
                } break;
            case phone.length > previousPhoneValue.length:
                switch (phone.length) {
                    case 1:
                        result = `(${phone}`; break;
                    case 4:
                        result = `${phone}) `; break;
                    case 5:
                        result = `${phone.slice(0, phone.length - 1)}) ${phone.slice(-1)}`; break;
                    case 9:
                        result = `${phone}-`; break;
                    case 10:
                        result = `${phone.slice(0, phone.length - 1)}-${phone.slice(-1)}`; break;
                    default:
                        result = phone;
                } break;
            default:
                result = phone; break;
        }
        return result;
    },

    hypenOneRemovedPhoneNumber: (phoneNumber) => phoneNumber.replace(/^1?-?(\d{3})-?(\d{3})-?(\d{4})$/, '$1$2$3'),

    formatPhoneNumber : (val) => {
        if (val) {
            return val.replace(/^\+?(\d{1})?(\d{3})(\d{3})(\d{4})$/, (_, a, b, c, d) => {
                let prefix = a ? `+${a} ` : '';
                return `${prefix}${b}-${c}-${d}`;
            });
        }
        return val;
    }
};